import { CancelButton, SaveButton } from "../../elements/ActionButtons/index";
import { Col, Grid, Row, FormGroup } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Component } from "react";

import Card from "../Card/Card";
import FormBuilder from "../../elements/FormBuilder/FormBuilder";
import MainContentHeader from "../Header/MainContentHeader";
import NotificationProvider from "../../elements/NotificationContent/Notifications";

import Button from "../../elements/CustomButton/CustomButton";
import SlidingPane from "react-sliding-pane";
import { viewPortDimension } from "../../tools/viewportDimension";
import ProjectActionButton from "./ProjectActionButton";
import SuperpositionHeader from "../../components/Header/SuperpositionHeader";

import ProjectReaffectSideModal from "./ProjectReaffectSideModal"

const initialProject = {
  name: "",
  tiersClientId: null,
  projectType: "",
  tiersCollaboratorId: null,
  dateFinPrevue: null,
  active: true
};

const schema = [
  {
    width: {
      sm: 12
    },
    fields: [
      {
        name: "name",
        type: "string",
        required: true,
        label: "ids_name",
        validation: value =>
          /^\s*$/.test(value) ? "ids_mustBeFilled" : null
      },
      {
        name: "tiersClientId",
        type: "selectClient",
        required: false,
        label: "ids_client"
      },
      {
        name: "projectType",
        type: "string",
        required: false,
        label: "ids_project"
      },
      {
        name: "tiersCollaboratorId",
        type: "selectCollaborator",
        required: false,
        label: "ids_collaborator"
      },
      {
        name: "dateFinPrevue",
        type: "date",
        required: false,
        label: "ids_dateFinPrevue"
      },
      {
        name: "active",
        type: "toggle",
        required: false,
        label: "ids_active",
        labels: {
          isTrue: "ids_active",
          isFalse: "ids_inactive"
        }
      }
    ]
  }
];

class ProjectSettingsForm extends Component {
  constructor(props) {
    super(props);
    this.form = null;
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cancel = this.cancel.bind(this);

    this.state = props.project ? props.project : initialProject;
    this.state.isPaneOpen = false;
    this.state.isReaffectPaneOpen = false;
  }

  handleSaveClick() {
    this.form.onSubmit();
  }

  cancel() {
    /* certainly not the best way, but it does the job */
    this.props.goBack();
  }

  onSubmit(project) {
    let errors = this.form.state.errors;
    if (!Object.values(errors).some(elm => elm !== null)) {
      console.log("ProjectSettingsFormonSubmit", project);
      this.props.saveProject(project);
      this.props.goBack();
    } else {
      let notif = NotificationProvider.getFailureNotification();
      notif.message = (
        <FormattedMessage
          id="ids_projectSettingsSaving_notification" />
      );
      this.props.sendNotification(notif);
    }
  }

  onReaffect(values) {
    let errors = this.form.state.errors;  

    // console.log("121 - values=", values);
    this.props.reaffectProject(values);

    // setTimeout(() => {
    //   this.props.goBack();
    // }, 5000);    
  }


  hideSideBar = async () => {
    this.setState({
      isPaneOpen: false,
      isReaffectPaneOpen: false
    });
  };

  showDeleteSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      isReaffectPaneOpen: false,

      paneTitleIds: this.props.intl.formatMessage({
        id: "ids_projectDeletion"
      }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmDeleteProject"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_projectHasBeenDeleted"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_errorProjectCouldNotBeDeleted"
      }),

      paneConfirmAction: async () => {
        return await this.props.deleteProject();
      }
    });
  };

  showReaffectSlidingPane = () => {
    this.setState({
      isPaneOpen: false,
      isReaffectPaneOpen: true
    });
  };


  onPaneConfirm = async event => {
    console.log("OnPaneConfirm");

    this.setState({ actionRunning: true });

    let bTest = await this.state.paneConfirmAction(event);

    console.log("145 - bTest=", bTest);

    if (
      bTest &&
      bTest.data &&
      bTest.data.deleteProjectAfterCheck &&
      bTest.data.deleteProjectAfterCheck.result
    ) {
      this.setState({ actionRunning: false });

      let notif = NotificationProvider.getSuccessNotification();
      notif.message = this.state.ids_paneActionSuccess;
      this.props.sendNotification(notif);

      this.setState({ isPaneOpen: false });
      setTimeout(() => {
        this.props.history.push("/settings/projects");
      }, 1500);

    } else {
      let notif = NotificationProvider.getFailureNotification();
      notif.message = this.state.ids_paneActionFailed;

      this.setState({ isPaneOpen: false });
      this.props.sendNotification(notif);
    }
  };

  renderActionButton() {
    if (this.props.role === "ADMIN" && this.props.project && this.props.project.isDeletable) {
      return (
        <ProjectActionButton
          availableActions={["DELETEPROJECT"]}
          deleteProject={() => {
            console.log("call showDeleteProjectSlidingPane", this);
            this.showDeleteSlidingPane();
          }}
        />
      );
    } else if (this.props.role === "ADMIN" && this.props.project && !!!this.props.project.isDeletable) {
      return (
        <ProjectActionButton
          availableActions={["REAFFECTPROJECT"]}
          reaffectProject={() => {
            console.log("call showReaffectProjectSlidingPane", this);
            this.showReaffectSlidingPane();
          }}
        />
      );
    } else {
      return <div />;
    }
  }

  renderNewHeader() {
    if (!this.props.inSideModal) {
      return (
        <FormattedMessage id={this.props.name}>
          {backBtnText => (
            <SuperpositionHeader
              backBtnText={backBtnText}
              transparent={true}
              handleMinimizeSidebar={this.props.handleMinimizeSidebar}
            >
              <div className="space-between">
                {this.renderActionButton()}
                <SaveButton
                  wd
                  onClick={this.handleSaveClick}
                  className="btn-fill pull-right"
                />
              </div>
            </SuperpositionHeader>
          )}
        </FormattedMessage>

        // <MainContentHeader sm={12} name={this.props.name} backUrl hasBtn={true}>
        //   <SaveButton
        //     wd
        //     onClick={this.handleSaveClick}
        //     className="btn-fill pull-right"
        //   />
        // </MainContentHeader>
      );
    }
    return <div />;
  }

  renderButton() {
    if (this.props.inSideModal) {
      return (
        <div className="side-modal-footer">
          <CancelButton wd onClick={this.props.cancel} />
          <SaveButton
            wd
            onClick={this.handleSaveClick}
            className="btn-fill pull-right margin-left-20"
          />
        </div>
      );
    }
    return <div />;
  }

  renderForm() {
    return (
      <FormBuilder
        companyId={this.props.companyId}
        intl={this.props.intl}
        ref={form => (this.form = form)}
        schema={schema}
        onSubmit={this.onSubmit}
        object={this.props.project || initialProject}
      />
    );
  }

  renderFormContainer() {
    if (this.props.inSideModal) {
      return this.renderForm();
    }
    return (
      <Col xs={12} sm={12} md={12} lg={12}>
        <Card>{this.renderForm()}</Card>
      </Col>
    );
  }
  render() {

    console.log("306 - props=", this.props);
    const dimension = viewPortDimension();
    const slidingPaneWidth =
      Math.min(dimension.width - 200, 800).toString() + "px";

    return (
      <div>
        <SlidingPane
          isOpen={this.state.isPaneOpen}
          title={this.state.paneTitleIds}
          width={slidingPaneWidth}
          onRequestClose={() => this.setState({ isPaneOpen: false })}>
          <div>
            <p>{this.state.paneContentIds}</p>
            <FormGroup>
              <CancelButton
                onClick={() => this.setState({ isPaneOpen: false })}
              />
              <Button
                icon
                fill
                wd
                bsStyle="primary"
                onClick={event => this.onPaneConfirm(event)}>
                <i className="fa fa-lg fa-check" />
                <FormattedMessage id="ids_confirm" />
              </Button>
            </FormGroup>
          </div>
        </SlidingPane>

        <ProjectReaffectSideModal
          title={this.props.intl.formatMessage({ id: "ids_reaffect" })}
          sideModalVisible={this.state.isReaffectPaneOpen === true ? this.state.isReaffectPaneOpen : false}
          close={() => this.hideSideBar()}
          confirm={(element) => {
            console.log("321 - confirm...");
            this.onReaffect(element);
          }}
          companyId={this.props.companyId}
          // bankAccounts={bankAccounts}
          intl={this.props.intl}
          sendNotification={this.props.sendNotification}
          formValues={this.state}
          // reaffectableToClient={this.props.project && this.props.project.reaffectableToClient}
          reaffectableToClient={true}
          // amount={this.state.invoice.totalTTC}
          // currencyId={this.state.invoice.currencyId}
        />

        {this.renderNewHeader()}
        <Grid fluid>
          {/* {this.renderHeader()} */}
          <div className="main-content">
            <Row>{this.renderFormContainer()}</Row>
            {this.renderButton()}
          </div>
        </Grid>
      </div>
    );
  }
}

export default injectIntl(ProjectSettingsForm, { withRef: true });
